import { IPortfolioBondLocal } from '@/finsight/domain/vo/PortfolioMonitor/ICreatePortfolioFormState';
import { IGetDealRouteParams } from '@/finsight/Router/RouteWithRedirect/getNewRoute';

export const getBondName = ({
  primaryIssuerTicker = '',
  primaryIssuerName = '',
  dealSeriesName = '',
  trancheClass = '',
}) => (
  `${ primaryIssuerTicker || primaryIssuerName } ${ dealSeriesName } ${ trancheClass }`.trim()
);

export const mapBondsToOptions = (bonds) => bonds.map((bond) => ({ label: getBondName(bond), value: bond }));

export const getFormattedBond = (
    { dealViewId, primaryIssuerName, primaryIssuerTicker, dealSeriesName }: IPortfolioBondLocal,
) => ({
  viewId: dealViewId,
  primaryIssuer: {
    name: primaryIssuerName,
  },
  issuerTicker: primaryIssuerTicker,
  seriesName: dealSeriesName,
}) as IGetDealRouteParams;
